import { createApp } from 'vue';
import VacationForm from './components/VacationForm.vue';
import VacationCalendar from './components/VacationCalendar.vue';
import LoginForm from './components/LoginForm.vue';
import RegistrationForm from './components/RegistrationForm.vue';
import PasswordResetForm from './components/PasswordResetForm.vue';
import VueConfetti from 'vue-confetti';
import { modals } from './parts/modals';
import UserPhoto from './components/UserPhoto.vue';
import UserInfo from './components/UserInfo.vue'


console.log('vue included');

// Mount the VacationCalendar
const calendarApp = createApp(VacationCalendar);
calendarApp.mount('#vacation-calendar');

// Mount the VacationForm
if (document.querySelector('#vacation-form')) {
  const formApp = createApp(VacationForm);
  formApp.use(VueConfetti); // Use vue-confetti
  formApp.mount('#vacation-form');
}

// Mount the LoginForm
if (document.querySelector('#login-form')) {
  const loginApp = createApp(LoginForm);

  loginApp.mount('#login-form');
}

// Mount the RegistrationForm
if (document.querySelector('#registration-form')) {
  const registrationApp = createApp(RegistrationForm);
  registrationApp.use(VueConfetti); // Use vue-confetti
  registrationApp.mount('#registration-form');
}

// Mount the PasswordResetForm
if (document.querySelector('#password-reset-form')) {
  const passwordResetApp = createApp(PasswordResetForm);
  passwordResetApp.mount('#password-reset-form');
}

// Mount UserPhoto
if (document.querySelector('#userPhoto')) {
  const userPhotoApp = createApp(UserPhoto);
  userPhotoApp.mount('#userPhoto');
}

// Mount UserInfo
if (document.querySelector('#userInfo')) {
  const userInfoApp = createApp(UserInfo);
  userInfoApp.mount('#userInfo');
}

document.addEventListener('DOMContentLoaded', () => {
  modals();
});
